import { createComponent } from '@fluentui/foundation-legacy';
import { TextView } from './Text.view';
import { TextStyles as styles } from './Text.styles';
export var Text = createComponent(TextView, {
    displayName: 'Text',
    styles: styles,
});
export default Text;
//# sourceMappingURL=Text.js.map